import React from 'react';
import { Navigate, Outlet, useLocation, useParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// Guards client-specific routes like /details/:client
export default function ClientGuard({ children }) {
  const { hasAccessToClient } = useAuth();
  const { client, clientId } = useParams();
  const resolvedClient = client || clientId;
  const location = useLocation();

  if (!resolvedClient || resolvedClient.toLowerCase() === 'all') {
    return children ? children : <Outlet />;
  }

  if (!hasAccessToClient(resolvedClient)) {
    return <Navigate to="/" replace state={{ from: location }} />;
  }

  return children ? children : <Outlet />;
}
